import script from "./upload-import.vue?vue&type=script&setup=true&lang=ts"
export * from "./upload-import.vue?vue&type=script&setup=true&lang=ts"

import "./upload-import.vue?vue&type=style&index=0&id=35fc8e51&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fc8e51"]])

export default __exports__